<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
    <div
      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
    >
      <span class="mr-2">
        {{ currentRecord }} - {{ maxRecordPage }} de {{ length }}
      </span>

      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
    </div>

    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="item in arrayOption"
        :key="item"
        @click="$emit('update', item)"
      >
        <span>{{ item }}</span>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  data() {
    return {
      arrayOption: [5, 10, 25, 50],
    };
  },
  props: ["currentPage", "itemsPerPage", "length"],
  computed: {
    currentRecord() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    maxRecordPage() {
      return this.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.length;
    },
  },
};
</script>

<style>
</style>
